import { Navigate, useParams } from 'react-router-dom';
import { determineCourseType } from '@/utils/routeUtils';
import { generateModuleRoute } from '@/utils/routeUtils';

/**
 * Redirects generic /courses/:courseId/:moduleId routes to their canonical category-specific routes
 * Example: /courses/datascience-advanced/ds-mlops -> /datascience-courses/datascience-advanced/ds-mlops
 */
export const CanonicalModuleRedirect = () => {
  const { courseId, moduleId } = useParams<{ courseId: string; moduleId: string }>();

  if (!courseId || !moduleId) {
    return <Navigate to="/courses" replace />;
  }

  // Determine the course type and generate the canonical route
  const courseType = determineCourseType(courseId);
  const canonicalRoute = generateModuleRoute(courseId, moduleId, courseType);
  
  // Get current path to compare
  const currentPath = `/courses/${courseId}/${moduleId}`;
  
  // If we're already on the canonical route, don't redirect
  if (currentPath === canonicalRoute) {
    return null; // Let the normal ModulePage handle this
  }

  // Redirect to canonical route
  return <Navigate to={canonicalRoute} replace />;
};
